// TODO
export enum InstallmentLabels {
  INSTALLMENT_DEFAULT_PAYMENT_OPTION = 'pay-in-full',
  INSTALLMENT_PAYMENT_OPTION_NAME = 'payment-type',
  INSTALLMENT_DEFAULT_PAYMENT_OPTION_LABEL = 'PAY IN FULL',
  INSTALLMENT_OPTION_MWI = 'MONTHS WITHOUT INTEREST',
  INSTALLMENT_OPTION_BNPL = 'BUY NOW PAY LATER'
}